function Tutorial() {
  return <div style={{ paddingTop: "120px" }}>Tutorijal</div>;
}

export default Tutorial;
